import React, { useEffect, useState } from "react";

import axios from "axios";
import cup from "../../../../../../../../assets/images/cup 2.png";
import AuditionCardReuse from "../../../../../../../AuditionAdmin/AuditionCardReuse";
import AllDataHeader from "../../../../../../../Reuseable/AllDataHeader";
import LoaderPost from "../../../../../../../Reuseable/LoaderPost";

const AuditionForFilterVideo = () => {
  const [event_data, setEvents] = useState([]);
  const [buffer, setBuffer] = useState(true);
  useEffect(() => {
    axios.get("/api/audition-admin/audition/lives").then((res) => {
      setBuffer(false);
      if (res.data.status === 200) {
        setEvents(res.data.lives);
      }
    });
  }, []);

  return (
    <>
      <AllDataHeader
        title="Filter live auditions videos"
        image={cup}
        count={"Zero"}
      />
      {buffer ? (
        <LoaderPost />
      ) : (
        <AuditionCardReuse
          data={event_data}
          urlLink={`/audition-admin/audition/round-video-filter`}
        />
      )}
    </>
  );
};

export default AuditionForFilterVideo;
